import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { _AssetItemHistory, _FixedAssetActiveHistoryByFixed, _FixedAssetItemDevaluation, _FixedAssetItemRevaluation } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";

interface Props {
    idItem: number;
}

export const FixedAssetActiveHistoryByFixed = ({ idItem }: Props) => {

    const fixeditemassetshistory = useDataBean(_FixedAssetActiveHistoryByFixed);
    const single = Singleton.getInstance();

    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idItem])

    const getLista = () => {

        fixeditemassetshistory.instance.getFixedAssetActiveHistoryByFixedAssetItem(idItem).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        fixeditemassetshistory.setBean({
            IDItem: fixeditemassetshistory.bean.IDItem
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        fixeditemassetshistory.deleteItemVoid(fixeditemassetshistory.bean.IDFixedAssetHistory).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        fixeditemassetshistory.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDFixedAssetHistory', visible: true },
        { title: 'Tipo Documento', property: 'Mnemonic', visible: true },
        { title: 'Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Fecha', property: 'InitDate', visible: true },
        { title: 'Grupo Activos Orígen', property: 'IDLine', visible: true },
        { title: 'Grupo Activos Destino', property: 'IDLineDestinity', visible: true },
        { title: 'Cuenta Orígen', property: 'BrandStrName', visible: true },
        { title: 'Cuenta Destino', property: 'BrandDestinityStrName', visible: true },

    ]




    return (
        <BasicPage titulo="Consultar Cambios de Grupo de Activos">
            <div className="row">
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={fixeditemassetshistory.setBean} ></BasicTable>

                </div>

            </div>
        </BasicPage>
    )
}